const buildRelatedValueParams = (relatedValue) => {
    const relatedValueAppend = [];

    if (typeof relatedValue === 'string') {
        relatedValue = relatedValue.split(',');
    }
    if (Array.isArray(relatedValue) && relatedValue.length > 0) {
        for (const val of relatedValue) {
            relatedValueAppend.push(`specialty_id[]=${val}`);
        }
    }

    return relatedValueAppend;
};

const buildSelectedValuesParams = (selectedValue) => {
    const selectedValueAppend = [];

    if (Array.isArray(selectedValue) && selectedValue.length > 0) {
        for (const val of selectedValue) {
            if (val !== '') {
                selectedValueAppend.push(`v[]=${val}`);
            }
        }
    }

    return selectedValueAppend;
};

const instanceSelect2 = ($input) => {
    const selected = $input.data('value') ?? '';
    const placeholder = $input.data('placeholder') ?? $input.attr('placeholder') ?? '';
    const isMultiple = ($input.attr('multiple') ?? '') === 'multiple';
    const source = $input.data('source');
    const related = $input.data('related');
    const $related = related ? $(related) : null;

    $input.select2({
        ajax: {
            url: () => {
                let params = buildSelectedValuesParams(selected.toString().split(','));

                const relatedValue = $related?.val();
                if (relatedValue !== null) {
                    params = [...params, ...buildRelatedValueParams(relatedValue)];
                }

                return `${source}?${params.join('&')}`;
            },
            dataType: 'json',
            delay: 400,
        },
        placeholder: placeholder,
        closeOnSelect: !isMultiple,
        allowClear: true,
        dropdownParent: $input.parent(),
    });

    $related?.on('select2:unselecting', () => {
        $input.val(null).trigger('change');
    });
};

const LicensesSearch = {
    init: () => {
        const $licenseSearchFields = $('[data-license-search="1"]');
        for (const field of $licenseSearchFields) {
            const $licenseSearch = $(field);
            instanceSelect2($licenseSearch);
        }
    },
};

export default LicensesSearch;
